"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _semanticUiReact = require("semantic-ui-react");

var _IconElement = _interopRequireDefault(require("../IconElement"));

require("moment-timezone");
/* eslint-disable class-methods-use-this, react/no-unused-prop-types */
// TODO better naming
// TODO organize functions
// TODO add groupBy prop for label and time


var HoursOfOperation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(HoursOfOperation, _React$Component);

  function HoursOfOperation() {
    (0, _classCallCheck2["default"])(this, HoursOfOperation);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(HoursOfOperation).apply(this, arguments));
  }

  (0, _createClass2["default"])(HoursOfOperation, [{
    key: "getHourGroups",
    value: function getHourGroups() {
      var _this = this;

      var _this$props = this.props,
          hours = _this$props.hours,
          displayOption = _this$props.displayOption;

      if (displayOption === 'daily') {
        return hours.map(function (_ref) {
          var open = _ref.open,
              close = _ref.close,
              label = _ref.label;
          return {
            label: _this.formatLabel(label),
            hoursValue: _this.createTimeValue({
              open: open,
              close: close
            })
          };
        });
      }

      var hoursGroups = this.groupHours();
      return hoursGroups.map(function (hoursGroup) {
        var hoursGroupLabel;

        if (hoursGroup.length === 1) {
          hoursGroupLabel = _this.createLabel(hoursGroup[0]);
        } else {
          hoursGroupLabel = _this.createLabel(hoursGroup[0], hoursGroup[hoursGroup.length - 1]);
        }

        var hoursValue = _this.createTimeValue(hoursGroup[0]);

        return {
          label: hoursGroupLabel,
          hoursValue: hoursValue
        };
      });
    }
  }, {
    key: "groupHours",
    value: function groupHours() {
      var hours = this.props.hours;
      var previousHoursGroupId = null;
      var hoursDividers = [];
      hours.forEach(function (hoursObj, index) {
        var open = hoursObj.open,
            close = hoursObj.close;
        var hoursId = "".concat(open, "_").concat(close);

        if (hoursId !== previousHoursGroupId && previousHoursGroupId !== null) {
          hoursDividers = [].concat((0, _toConsumableArray2["default"])(hoursDividers), [index]);
        }

        previousHoursGroupId = hoursId;
      });

      if (hoursDividers.length === 0) {
        return [hours];
      }

      console.log(hoursDividers);
      return hoursDividers.reduce(function (acc, divider, index) {
        if (index === hoursDividers.length - 1) {
          return [].concat((0, _toConsumableArray2["default"])(acc), [hours.slice(hoursDividers[index - 1], divider), hours.slice(divider)]);
        } else if (index === 0) {
          return [hours.slice(0, divider)];
        } else {
          return [].concat((0, _toConsumableArray2["default"])(acc), [hours.slice(hoursDividers[index - 1], divider)]);
        }
      }, []);
    }
  }, {
    key: "createTimeValue",
    value: function createTimeValue(_ref2) {
      var open = _ref2.open,
          close = _ref2.close; // TODO add timezoneing in
      // TODO figure out 0-2400 issue
      // parse times

      var openingTime = open === 0 || open === 2400 ? 'Midnight' : (0, _moment["default"])(open, 'hmm').format('h:mma');
      var closingTime = close === 0 || close === 2400 ? 'Midnight' : (0, _moment["default"])(close, 'hmm').format('h:mma'); // handle special cases

      var isClosed = !open;
      var isOpenAllDay = open === close;
      var isClosedLabel = 'Closed';
      var isOpenAllDayLabel = 'Open 24 Hours';
      if (isClosed) return isClosedLabel;
      if (isOpenAllDay) return isOpenAllDayLabel;
      return "".concat(openingTime, " - ").concat(closingTime);
    }
  }, {
    key: "createLabel",
    value: function createLabel(a) {
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var firstLabel = this.formatLabel(a.label);

      if (b !== null) {
        var secondLabel = this.formatLabel(b.label);
        return "".concat(firstLabel, " - ").concat(secondLabel);
      }

      return firstLabel;
    }
  }, {
    key: "formatLabel",
    value: function formatLabel(label) {
      var _this$props2 = this.props,
          capitalizeLabels = _this$props2.capitalizeLabels,
          truncateLabels = _this$props2.truncateLabels;
      var displayedLabel = truncateLabels ? label.slice(0, 3) : label;
      return capitalizeLabels ? displayedLabel.toUpperCase() : displayedLabel;
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this$props3 = this.props,
          header = _this$props3.header,
          subheader = _this$props3.subheader;
      return _react["default"].createElement(_react["default"].Fragment, null, header && _react["default"].createElement(_semanticUiReact.Header, {
        as: "h2"
      }, header), subheader && _react["default"].createElement(_semanticUiReact.Header, {
        as: "h3"
      }, subheader));
    }
  }, {
    key: "renderHours",
    value: function renderHours() {
      var _this$props4 = this.props,
          orientation = _this$props4.orientation,
          animated = _this$props4.animated,
          celled = _this$props4.celled,
          inlineHours = _this$props4.inlineHours;
      var hourGroups = this.getHourGroups();
      var isHorizontal = orientation === 'horizontal';
      return _react["default"].createElement(_semanticUiReact.List, {
        horizontal: isHorizontal,
        animated: animated,
        celled: celled,
        relaxed: true
      }, hourGroups.map(function (_ref3) {
        var label = _ref3.label,
            hoursValue = _ref3.hoursValue;
        return _react["default"].createElement(_semanticUiReact.List.Item, {
          key: label
        }, _react["default"].createElement(_semanticUiReact.List.Content, null, _react["default"].createElement(_semanticUiReact.List.Header, {
          as: "h4"
        }, label, inlineHours && ": ".concat(hoursValue)), !inlineHours && _react["default"].createElement(_semanticUiReact.List.Description, null, hoursValue)));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          className = _this$props5.className,
          showIcon = _this$props5.showIcon;

      var content = _react["default"].createElement("div", {
        className: className
      }, this.renderHeader(), this.renderHours());

      return showIcon ? _react["default"].createElement(_IconElement["default"], {
        iconType: "clock",
        element: content,
        iconPosition: "top"
      }) : content;
    }
  }], [{
    key: "timesAreEqual",
    value: function timesAreEqual(a, b) {
      return a.open === b.open && a.close === b.close;
    }
  }]);
  return HoursOfOperation;
}(_react["default"].Component);

exports["default"] = HoursOfOperation;
HoursOfOperation.propTypes = {
  hours: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    day: _propTypes["default"].number.isRequired,
    open: _propTypes["default"].number.isRequired,
    close: _propTypes["default"].number.isRequired,
    label: _propTypes["default"].string
  })).isRequired,
  animated: _propTypes["default"].bool,
  capitalizeLabels: _propTypes["default"].bool,
  celled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  displayOption: _propTypes["default"].oneOf(['daily', 'grouped']),
  header: _propTypes["default"].string,
  inlineHours: _propTypes["default"].bool,
  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical']),
  showIcon: _propTypes["default"].bool,
  subheader: _propTypes["default"].string,
  timezone: _propTypes["default"].string,
  truncateLabels: _propTypes["default"].bool
};
HoursOfOperation.defaultProps = {
  animated: false,
  capitalizeLabels: false,
  celled: false,
  className: '',
  displayOption: 'daily',
  header: '',
  inlineHours: false,
  orientation: 'vertical',
  showIcon: false,
  subheader: '',
  timezone: 'EST',
  truncateLabels: false
};
HoursOfOperation.propOptions = {
  header: ['Hours of Operation', 'Our Hours', '']
};
HoursOfOperation.dataPropsMap = {
  hours: ['business', 'primary_location', 'hours']
};